<template>
  <div class="content-edit">

    <el-form ref="poolForm" :model="poolForm" :rules="poolRules" label-width="130px" size="small">
      <div class="white-container mb30">
        <p class="mb30">基础信息</p>
        <el-form-item label="抽奖标题" prop="name" style="width: 464px">
          <el-input v-model="poolForm.name" maxlength="6" :disabled="handleType == 'preview'" placeholder="请输入抽奖标题，最多不超过6个字" />
        </el-form-item>
        <el-form-item label="抽奖规则链接" prop="rulesUrl" style="width: 764px">
          <el-input v-model="poolForm.rulesUrl" :disabled="handleType == 'preview'" placeholder="请输入抽奖规则链接" />
        </el-form-item>
        <el-form-item label="个人限制" prop="perLimit" style="width: 764px">
          <el-input v-model="poolForm.perLimit" type="number" :disabled="handleType == 'preview'" placeholder="请输入" style="width: 80px;height: 34px;" />
          <span>&nbsp;&nbsp;次</span>
        </el-form-item>
        <el-form-item label="每日限制" prop="dayLimit" style="width: 764px">
          <el-input v-model="poolForm.dayLimit" type="number" :disabled="handleType == 'preview'" placeholder="请输入" style="width: 80px;height: 34px;" />
          <span>&nbsp;&nbsp;次</span>
        </el-form-item>
        <el-form-item v-if="handleType !='preview'" style="width: 100%; margin-left: -50px;">
          <div class="flex btns">
            <el-button class="btn" type="info" @click="handleCancel">取消</el-button>
            <el-button class="btn" type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
      <div v-if="poolForm.id" class="white-container">
        <p class="mb30"> <span style="color:#dc0019">*</span> 抽奖信息</p>
        <template v-for="(item, index) in awardList">
          <CouponsAward v-if="item.type == 1" :key="index" :handle-type="handleType" :item="item" :index="index" @handleAward="handleAward" />
          <GoodsAward v-if="item.type == 2" :key="index" :handle-type="handleType" :item="item" :index="index" @handleAward="handleAward" />
          <ExperienceClass v-if="item.type == 3" :key="index" :handle-type="handleType" :item="item" :index="index" @handleAward="handleAward" />
          <AccumulatePoints v-if="item.type == 4" :key="index" :handle-type="handleType" :item="item" :index="index" @handleAward="handleAward" />
        </template>
        <div v-if="handleType !='preview'" class="add-award-btn">
          <el-button :disabled="handleType == 'preview'" plan icon="el-icon-plus" size="small" style="width: 150px;" @click="addGoodsAward">添加实物奖品</el-button>
          <!-- <el-button :disabled="handleType == 'preview'" plan icon="el-icon-plus" size="small" style="width: 150px;" @click="addCouponsAward">EC优惠券</el-button> -->
          <el-button :disabled="handleType == 'preview'" plan icon="el-icon-plus" size="small" style="width: 150px;" @click="addExperienceClass">添加体验课</el-button>
          <el-button :disabled="handleType == 'preview'" plan icon="el-icon-plus" size="small" style="width: 150px;" @click="addAccumulatePoints">添加积分</el-button>
        </div>
        <div v-if="handleType =='preview'" class="add-award-btn">
          <el-button class="btn" style="width: 120px;" type="primary" @click="goback">返回</el-button>
        </div>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />

  </div>
</template>
<script>
import Dialog from "@/components/Dialog";
import GoodsAward from "../components/goodsAward.vue";
import CouponsAward from "../components/couponsAward.vue";
import ExperienceClass from "../components/experienceClass.vue";
import AccumulatePoints from "../components/accumulatePoints.vue";
const awardItem = {
  fullName: "",
  id: null,
  name: "",
  odds: null,
  picUrl: "",
  stock: null,
  thirdRel: "",
};
export default {
  components: { Dialog, GoodsAward, CouponsAward, ExperienceClass, AccumulatePoints },
  data() {
    return {
      poolForm: {
        id: null,
        name: "",
        rulesUrl: "",
        dayLimit: null,
        perLimit: null,
      },
      awardList: [
      ],
      formDialogShow: false,
      information: {},
      poolRules: {
        name: [
          { required: true, message: "请输入活动标题", trigger: ["blur"] },
        ],
        /* eventName: [
          { required: true, message: "请输入积分事件", trigger: ["blur"] },
        ],
        eventRemark: [
          { required: true, message: "请输入积分事件备注", trigger: ["blur"] },
        ], */
        rulesUrl: [
          { required: true, message: "请输入抽奖规则链接", trigger: ["blur"] },
        ],
        perLimit: [
          { required: true, message: "请输入个人限制", trigger: ["blur"] },
        ],
        dayLimit: [
          { required: true, message: "请输入每日限制", trigger: ["blur"] },
        ],
      },
      handleType: '',
    };
  },
  async created() {
  },
  mounted() {
    const { query } = this.$route;
    const { id, type } = query;
    if (id && type) {
      this.handleType = type;
      this.oldId = id;
      this.fetchPool(this.oldId);
    } else {
      this.handleType = 'add';
    }
  },
  beforeDestroy() { },
  methods: {
    submit() {
      this.$refs.poolForm.validate().then(res => {
        if (res) {
          this.formDialogShow = true;
          this.information = {
            operation: "submit",
            icon: "warn",
            subTitle: "是否确认保存编辑的内容？",
          };
        }
      });
    },
    addPool() {
      const params = {
        ...this.poolForm,
        id: this.poolForm.id,
      };
      if (this.handleType === 'copy') {
        params.id = null;
      }
      this.$Api.newCamp.lotteryPoolAdd(params).then(id => {
        this.poolForm.id = id;
        this.$message.success('新增成功');
      });
    },
    editPool() {
      this.$Api.newCamp.lotteryPoolEdit(this.poolForm).then(res => {
        this.$message.success('编辑成功');
      });
    },
    async fetchPool(id) {
      this.$Api.newCamp.lotteryPrizeDetails(id).then(res => {
        this.poolForm = res;
        this.awardList = res.meridianCampPrizeInfoAddDTOList;
      });
    },
    // 取消
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃本次更改，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        if (this.handleType === 'edit') {
          this.editPool();
        } else {
          this.addPool();
        }
      }
    },
    goback() {
      this.$router.go(-1);
    },
    addGoodsAward() {
      this.awardList.push({ ...awardItem, type: 2, poolId: this.poolForm.id });
    },
    addCouponsAward() {
      this.awardList.push({ ...awardItem, type: 1, poolId: this.poolForm.id });
    },
    addExperienceClass() {
      this.awardList.push({ ...awardItem, type: 3, poolId: this.poolForm.id });
    },
    addAccumulatePoints() {
      this.awardList.push({ ...awardItem, type: 4, poolId: this.poolForm.id });
    },
    handleAward(data) {
      const { index, item, type } = data;
      if (type === 'del') {
        if (item.id) {
          this.$Api.newCamp.lotteryPrizeDelete(this.poolForm.id, item.id).then(res => {
            this.awardList.splice(index, 1);
          });
        } else {
          this.awardList.splice(index, 1);
        }
      } else if (type === 'reset') {
        this.awardList[index] = {
          ...awardItem,
          type: item.type,
          poolId: this.poolForm.id,
          id: item.id,
        };
        this.awardList = [...this.awardList];
      } else if (type === 'save') {
        /* let countOdds = this.awardList.reduce((acc, cur, idx) => {
          countOdds += +cur.odds;
          return countOdds;
        }, 0);
        if (countOdds > 100) {
          this.$message.error('中奖概率总和不能超过100%。请检查并重新输入');
          return;
        } */
        if (!item.name || !item.stock || !item.odds) {
          this.$message.error('请填写完整信息');
          return;
        }
        if (+item.type === 1 && !item.thirdRel) {
          this.$message.error('请填写完整信息');
          return;
        }
        if (+item.type === 2 && (!item.picUrl || !item.fullName)) {
          this.$message.error('请填写完整信息');
          return;
        }
        if (+item.type === 4 && (!item.eventName || !item.eventRemark)) {
          this.$message.error('请填写完整信息');
          return;
        }
        const params = {
          ...item,
          poolId: this.poolForm.id,
          id: item.id,
          order: index,
          odds: +item.odds,
          stock: +item.stock,
        };
        this.$Api.newCamp.lotteryPrizeAddAndEdit(params).then(res => {
          console.log('res*****', res);
          this.awardList[index] = res;
          this.awardList = [...this.awardList];
          this.fetchPool(this.poolForm.id);
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mb30{
  margin-bottom: 30px;
}
.content-edit {
  .btns {
    align-items: center;
    justify-content: center;
    .btn{
      width: 120px;
      height: 40px;
    }
  }
  .marginTop {
    margin-top: 30px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
}
.white-container{
  padding-bottom: 1px;
}
.uploadImg-wrapper{
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-left: -76px;
}
.add-award-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
  .el-button{
    border-style: dashed;
  }
}
</style>
